import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const DOLCH_SPACE_ACTIVITY_FRAGMENT = gql `
  fragment DolchSpaceActivityFragment on DolchSpaceActivity {
    rounds {
      answer
      answerAudio {
        audio {
          ...AssetFragment
        }
      }
      colorImage {
        image {
          ...AssetFragment
        }
      }
      monochromeImage {
        image {
          ...AssetFragment
        }
      }
      phrase
    }
  }
  ${ASSET_FRAGMENT}
`;
export default DOLCH_SPACE_ACTIVITY_FRAGMENT;
